<template>
  <div id="master-detailpage">
    <TabView v-model:activeIndex="activeTab">
      <template v-if="$auth.canView('user_permissions/list')">
        <TabPanel>
          <template #header>
            <div class="text-lg font-bold">Role Permissions</div>
          </template>
          <div>
            <UserPermissionsListPage
              ref="userPermissionsListPage"
              field-name="user_permissions.role_id"
              :field-value="masterRecord.role_id"
              :show-header="true"
              v-if="pageReady"
            >
            </UserPermissionsListPage>
          </div>
        </TabPanel>
      </template>
    </TabView>
  </div>
</template>
<script setup>
import { watch, computed, ref, onMounted } from "vue";
import { useStore } from "vuex";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import UserPermissionsListPage from "../user_permissions/list.vue";
const props = defineProps({
  isSubPage: {
    type: Boolean,
    default: true,
  },
  scrollIntoView: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const auth = useAuth();
const store = useStore();
const masterRecord = computed(() => store.getters["user_roles/currentRecord"]);
const activeTab = ref(0);
const pageReady = ref(true);
//scroll detail page into view
function scrollToDetailPage() {
  if (props.scrollIntoView) {
    const pageElement = document.getElementById("master-detailpage");
    if (pageElement) {
      pageElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }
}
// pass form data from master to detail
function setDetailPageFormData() {
  const record = masterRecord.value;
  // set  form data
  const user_permissionsFormData = { role_id: record?.role_id };
  store.commit("user_permissions/setFormData", user_permissionsFormData);
}
watch(
  () => masterRecord,
  (current) => {
    setDetailPageFormData();
    scrollToDetailPage();
  },
  { deep: true, immediate: true }
);
onMounted(() => {
  scrollToDetailPage();
});
</script>
